export default "__VITE_ASSET__Jl$gDgzv__"